export default __webpack_public_path__ + "static/media/defaultUser.b89d2151.svg";